import {
  FormControlLabel,
  Radio,
  RadioGroup,
  RadioGroupProps,
  Theme,
  useTheme,
} from '@mui/material'
import { ReactNode } from 'react'
import ZText from './ZText'

interface ZRadioProps extends RadioGroupProps {
  options: Array<{
    value: string
    label: string
    subLabel?: string
    checked?: boolean
  }>
  box?: boolean
  renderAfterOption?: (optionValue: string) => ReactNode
}

const ZRadio = (props: ZRadioProps) => {
  const theme = useTheme<Theme>()

  const { box, options, renderAfterOption, ...rest } = props

  return (
    <RadioGroup {...rest}>
      {options.map(option => (
        <div key={option.value}>
          <FormControlLabel
            value={option.value}
            control={
              <Radio
                checked={option.checked}
                style={{
                  color: theme.palette.primary.main,
                }}
              />
            }
            label={
              <div
                style={{
                  paddingTop: '0.5rem',
                  paddingBottom: box ? '0.5rem' : undefined,
                }}
              >
                <ZText>{option.label}</ZText>
                {option.subLabel ? (
                  <ZText style={{ fontWeight: '300' }} variant="body2">
                    {option.subLabel}
                  </ZText>
                ) : null}
              </div>
            }
            style={
              box
                ? {
                    borderWidth: '1px',
                    borderColor: theme.palette.primary.main,
                    borderStyle: 'solid',
                    borderRadius: 10,
                    padding: '1rem 1rem 1rem 1rem',
                    margin: '0 0 1rem 0',
                    width: '100%',
                    alignItems: 'flex-start',
                  }
                : {
                    margin: 0,
                    alignItems: 'flex-start',
                  }
            }
          />
          {renderAfterOption?.(option.value)}
        </div>
      ))}
    </RadioGroup>
  )
}

export default ZRadio
